import React, { lazy, Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { Atom } from "react-loading-indicators";
import { useFirebase } from './context/firebase.context'; // Import your Firebase context

// CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Components
import MyNavbar from './components/Navbar.components';
import Footer from './components/Footer.components';
import SchoolArticles from './components/SchoolArticles';
import Form from './components/Form.components';
import EventList from './components/EventList';
import PhotoGallery from "./components/PhotoGallery";
import SchoolManager from './components/SchoolManager';
import StudentsBySchool from './components/StudentsBySchool ';
const EventForm = lazy(() => import("./components/EventForm.comp"));
const PhotoManager = lazy(() => import("./components/PhotoManager.comp"));

// Pages
const HomePage = lazy(() => import('./pages/Home.pages'));
const LoginPage = lazy(() => import('./pages/Login.pages'));
const RegisterPage = lazy(() => import('./pages/Register.pages'));

function App() {
    const { isLoggedIn } = useFirebase(); // Access `isLoggedIn` from Firebase context

    return (
        <div className="App">
            <MyNavbar />
            <Suspense fallback={<Atom color="#3172cc" size="large" text="Please Wait....." textColor="" />}>
                <Routes>
                    {/* Check login status */}
                    {isLoggedIn ? (
                        <>
                            {/* Protected routes */}
                            <Route path="/" element={<HomePage />} />
                            <Route path="/add-student" element={<Form />} />
                            <Route path="/add-events" element={<EventForm />} />
                            <Route path="/add-images" element={<PhotoManager />} />
                            <Route path="/school-list" element={<SchoolArticles />} />
                            <Route path="/events-list" element={<EventList />} />
                            <Route path="/photos-list" element={<PhotoGallery />} />
                            <Route path="/hello-world" element={<h1>Hello World</h1>} />
                        </>
                    ) : (
                        // Redirect to login if not logged in
                        <>
                            <Route path="*" element={<Navigate to="/login" replace />} />
                        </>
                    )}
                    {/* Public routes */}
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                </Routes>
            </Suspense>
            <Footer />
        </div>
    );
}

export default App;
